// F1 fix (re-review of f93806e, 2026-10-31 — same privacy class as B2, via
// localStorage instead of the SW cache): the persisted permission/entitlement
// snapshots (vecindus_permissions:* / vecindus_entitlements:*) survive account
// switches on any login path that bypasses clearAuth (api.ts 401 session-wipe,
// password/OTP/2FA logins), so account B on a shared tablet could be served
// account A's snapshot offline. Import-safe leaf module (no imports) so both
// AuthContext AND services/api.ts can call it without import cycles.
const STORE_PREFIXES = ['vecindus_permissions:', 'vecindus_entitlements:'];

export function clearPermissionsStores(): void {
  try {
    Object.keys(localStorage)
      .filter((key) => STORE_PREFIXES.some((prefix) => key.startsWith(prefix)))
      .forEach((key) => localStorage.removeItem(key));
  } catch { /* storage optional */ }
}
